module.exports = __webpack_public_path__ + "img/torch-2.55bbc2fc.jpg";